<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Deleted Extra-Services</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-extraServices' }">Back</router-link>
          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="extraServices.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(extraService, index) in filteredExtraServices" :key="index">
                  <th scope="row">{{ extraService.id }}</th>
                  <td>{{ extraService.name_ar }}</td>
                  <td>{{ extraService.name_en }}</td>
                  <td>{{ extraService.Price }}</td>
                  <td>{{ extraService.available }}</td>

                  <td>
                    <button class="me-2 btn btn-danger" @click="restoreExtraService(extraService.id)">
                      Restore
                    </button>

                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No ExtraService found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
import axios from "../../Axios";
export default {
  name: "AllExtraServices",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      extraServices: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
        { label: 'Price', key: 'price' },
        { label: 'Available', key: 'available' },
      ],
    };
  },

  async created() {
    this.fetchExtraServices();
  },

  computed: {
    filteredExtraServices() {
      if (!this.searchTerm) {
        return this.extraServices;
      }
      const term = this.searchTerm.toLowerCase();
      return this.extraServices.filter(
        (extraService) =>
          extraService.name.toLowerCase().includes(term)

      );
    },
  },

  methods: {
    // fetch orders
    async fetchExtraServices() {
      try {
        const response = await axios.get(
          `/admin/admin/extra-service/get-delete-soft`
        );
        this.extraServices = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching extra-service:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    restoreExtraService(id) {
      axios
        .post(`/admin/admin/extra-service/restore?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchExtraServices();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>